module.exports = __webpack_public_path__ + "img/icon-menu-category.db55914a.svg";